import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, Crown, ArrowRight, Sparkles } from 'lucide-react';
import { useSubscription } from '../context/SubscriptionContext';

export default function CheckoutSuccessPage() {
  const navigate = useNavigate();
  const { refreshSubscription } = useSubscription();

  // Refresh subscription on mount
  useEffect(() => {
    refreshSubscription();
  }, []);

  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center text-center px-4">
      {/* Success Animation */}
      <div className="relative mb-6">
        <div className="w-24 h-24 rounded-full bg-gradient-to-br from-green-400 to-green-600 flex items-center justify-center animate-bounce-slow">
          <CheckCircle className="w-12 h-12 text-white" />
        </div>
        <div className="absolute -top-2 -right-2">
          <Sparkles className="w-8 h-8 text-amber-400 animate-pulse" />
        </div>
      </div>

      {/* Message */}
      <h1 className="text-2xl font-bold text-surface-900 mb-2">
        Welcome to Premium!
      </h1>
      <p className="text-surface-600 mb-8 max-w-sm">
        Your subscription is now active. You have full access to all premium features.
      </p>

      {/* Features Unlocked */}
      <div className="bg-gradient-to-br from-primary-50 to-accent-50 rounded-2xl p-6 mb-8 max-w-sm w-full">
        <div className="flex items-center gap-2 mb-4">
          <Crown className="w-5 h-5 text-primary-600" />
          <span className="font-semibold text-primary-900">Features Unlocked</span>
        </div>
        <ul className="space-y-2 text-left">
          {[
            'Unlimited transactions',
            'Advanced insights & analytics',
            'Receivables & debts tracking',
            'Data export (Excel/CSV)',
            'Priority support'
          ].map((feature, index) => (
            <li key={index} className="flex items-center gap-2 text-sm text-primary-800">
              <CheckCircle className="w-4 h-4 text-green-500 flex-shrink-0" />
              {feature}
            </li>
          ))}
        </ul>
      </div>

      {/* CTA Buttons */}
      <div className="space-y-3 w-full max-w-sm">
        <button
          onClick={() => navigate('/')}
          className="w-full py-3.5 rounded-xl bg-gradient-to-r from-primary-500 to-accent-500 text-white font-semibold flex items-center justify-center gap-2 hover:opacity-90 transition-opacity"
        >
          Go to Dashboard
          <ArrowRight className="w-5 h-5" />
        </button>
        <button
          onClick={() => navigate('/subscription')}
          className="w-full py-3.5 rounded-xl bg-surface-100 text-surface-700 font-medium hover:bg-surface-200 transition-colors"
        >
          View Subscription Details
        </button>
      </div>
    </div>
  );
}
